@if (dataSet) {
  <section class="bgWhite">
    <section class="col-md-12 col-sm-12 col-xs-12">
      <div class="manage-week">
        <form [formGroup]="manageShipWeekForm">
          <!-- <form> -->
          <div class="shippingContent">
            <h4>STS Manage Ship Weeks</h4>
            <div class="Fields-btn-group">
              <button type="button" class="btn btn-default stsblue-button checkButton" (click)="checkAll()">
                Check all
              </button>
              <button type="button" class="btn btn-default stsblue-button unCheckButton" (click)="unCheckAll()">
                Uncheck all
              </button>
            </div>
          </div>
          <div class="sts-cust-upld">
            <table id="backoffice-table" class="shipping-table backoffice-table display" style="width:100%">
              <thead>
                <tr class="heading">
                  <th class="date-range">Week date range</th>
                  @for (ship of shipWeekDetails?.availableMaterials; track ship) {
                    <th class="dose-range">{{ ship?.code }}</th>
                    <th class="order no-sort">
                      Available doses {{ ship?.code }}
                    </th>
                  }
                </tr>
              </thead>
              <tbody class="datatable-row" formArrayName="rows">
                @for ( row of manageShipWeekForm.get('rows').controls; track  row; let i = $index) {
                  <tr class="week-table-row" [formGroupName]="i">
                    <ng-container  formArrayName="shippingWeekList">
                      <td class="text-center">Week of {{ row.value.shippingWeek }}</td>
                      @for (
                        row of row.controls['shippingWeekList'].controls; track
                        row; let i2 = $index) {
                        <ng-container
                          [formGroupName]="i2">
                          <td class="text-center">
                            <input
                              type="checkbox"
                              id="checkbox_{{ i2 }}_{{i}}"
                              formControlName="available"
                              (change)="checkUncheckBox($event.target.value,i2,i)"
                              [checked]="row.value.available"/>
                            <span class="checkmark"></span>
                          </td>
                          <td class="text-center">
                            <div class="Fields-container">
                              <input type="text" id="quantity_{{i2}}_{{i}}" maxlength="10" formControlName="quantity"  class="Fields-input field-optional form-control text-center"  autocomplete="off" [ngbPopover]="warningTooltip"
                                triggers="manual" #p3="ngbPopover" placement="top" (keyup)="quantityValidation($event.target.value,i2,i,p3)"
                                container="body" popoverClass="popover-links stsWarningPopover"/>
                            </div>
                            <ng-template #warningTooltip>
                              <div class="warningContent">
                                <div class="imgBlock">
                                  <img src="/icons/warning_red_new.png" class="positive-green-icon"
                                    alt="success">
                                </div>
                                <div class="contentBlock">
                                  <span class="warningMsg">
                                    Cannot update quantity.<br>
                                    {{row.value.sceduledDoses}} doses already scheduled.
                                  </span>
                                </div>
                              </div>
                            </ng-template>
                          </td>
                        </ng-container>
                      }
                    </ng-container>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="updateBtnBlock">
            <button type="button" class="btn btn-default stsblue-button updateButton" (click)="updateShipData()" [disable]="buttonDisable">
              Update
            </button>
          </div>
        </form>
      </div>
    </section>
  </section>
}
